import { render } from "./MyUploadImage.vue?vue&type=template&id=53317e0f&scoped=true"
import script from "./MyUploadImage.vue?vue&type=script&lang=js"
export * from "./MyUploadImage.vue?vue&type=script&lang=js"

import "./MyUploadImage.vue?vue&type=style&index=0&id=53317e0f&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-53317e0f"]])

export default __exports__